<div class="tooltips">
  <mojo-pdf-preview-tooltip
    class="preview-link"
    [candidate]="candidate"
    [linkText]="linkText"
    [icon]="icon"
    [fromNotes]="fromNotes"
    [iconEnlarge]="iconEnlarge"
  >
  </mojo-pdf-preview-tooltip>

  <ng-container *mojoHasFeatureExtension="coverLetterFE">
    <mojo-pdf-preview-tooltip
      *ngIf="hasCoverLetter$ | async"
      class="preview-link"
      [candidate]="candidate"
      linkText="Cover letter"
      [icon]="icon"
      [fromNotes]="fromNotes"
      [iconEnlarge]="iconEnlarge"
    >
    </mojo-pdf-preview-tooltip>
  </ng-container>
</div>
